import { dataCollectionStatementsQueryOptions } from '../../hooks/data/useDataCollectionStatements'
import { queryClient } from '../../queryClient'
import type { DataCollectionStatement } from '../../types/apiModels'

export const findDCSByMetricEventId = async ({
  farmId,
  userRole,
  metricEventId,
}: {
  farmId: string
  userRole: string
  metricEventId: string
}): Promise<DataCollectionStatement | undefined> => {
  const options = dataCollectionStatementsQueryOptions({ farmId, userRole })
  const containsMetricEvent = (statement: DataCollectionStatement) =>
    statement.metricsEventsIds.includes(metricEventId)
  const cachedAt = queryClient.getQueryState(options.queryKey)?.dataUpdatedAt

  // fetchQuery, not ensureQueryData: an entry a DCS action invalidated must be read again.
  const statement = (await queryClient.fetchQuery(options)).find(containsMetricEvent)
  const servedFromCache = queryClient.getQueryState(options.queryKey)?.dataUpdatedAt === cachedAt
  if (statement || !servedFromCache) return statement

  // A metric event created after the list was cached is missing from it until the next read.
  return (await queryClient.fetchQuery({ ...options, staleTime: 0 })).find(containsMetricEvent)
}
